export default {
  name: 'footer-copyright',
  label: {
    title: '页脚版权',
    icon: require('@/assets/icon-component-label_FooterCopyright.svg'),
    limit: 1
  },
  sort: 1005
}
